export default "__VITE_PUBLIC_ASSET__90e736b1__"